// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*:focus {
    outline: none;
}

.GridView {
}

.GridRow {
    position: relative;
    display: flex;
    flex-direction: row;
}

.GridColumn {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}

.LeftSideGridContainer {
    flex: 0 0 75px;
    z-index: 10;
    border-right: 1px solid #f2f2f2;
}

.LeftSideGridContainer.scroll {
    box-shadow: 4px 0 0 0 rgba(0,0,0,0.04);
}

.LeftSideGrid {
    overflow: hidden !important;
}

.HeaderGrid {
    width: 100%;
    overflow: hidden !important;
    border-bottom: 1px solid #f2f2f2;
    background-color: hsla(0,0%,100%,0.5);
}

.HeaderGrid.scroll {
    box-shadow: 0 4px 0 0 rgba(0,0,0,0.04);
}

.BodyGrid {
    width: 100%;
}

.evenRow {}

.oddRow {
    background-color: rgba(0, 0, 0, .1);
}

.cell,
.headerCell,
.leftCell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.headerCell {
    background-color: #fff;
    padding: 0 8px;
    white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;
}

.headerCell:first-of-type {
    border-left: none;
}

.cell {
    background-color: #fff;
    border-bottom: 1px solid #f2f2f2;
    font-size: 13px;
    padding: 0 8px;
    white-space: nowrap;
    cursor: pointer;
    color: #737373;
}

.cell.hover {
    background:#f7fbff;
}

.cell.active {
    margin-top: -1px;
    border-top: 1px solid #2d7ff9;
    border-bottom: 1px solid #2d7ff9;
    z-index: 1000 !important;
}

.cellFocus {
    border-color: transparent;
    box-shadow: 0 0 0 2px #2d7ff9 !important;
    border-radius: 1px;
    z-index: 1000 !important;
}

.addRecordCell {
    border-right: none;
    border-left: none;
}

.headerCell,
.leftCell {
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/GridView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,WAAW;AACf;;AAEA,UAAU;;AAEV;IACI,mCAAmC;AACvC;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;AACrB","sourcesContent":["*:focus {\n    outline: none;\n}\n\n.GridView {\n}\n\n.GridRow {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n}\n\n.GridColumn {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n}\n\n.LeftSideGridContainer {\n    flex: 0 0 75px;\n    z-index: 10;\n    border-right: 1px solid #f2f2f2;\n}\n\n.LeftSideGridContainer.scroll {\n    box-shadow: 4px 0 0 0 rgba(0,0,0,0.04);\n}\n\n.LeftSideGrid {\n    overflow: hidden !important;\n}\n\n.HeaderGrid {\n    width: 100%;\n    overflow: hidden !important;\n    border-bottom: 1px solid #f2f2f2;\n    background-color: hsla(0,0%,100%,0.5);\n}\n\n.HeaderGrid.scroll {\n    box-shadow: 0 4px 0 0 rgba(0,0,0,0.04);\n}\n\n.BodyGrid {\n    width: 100%;\n}\n\n.evenRow {}\n\n.oddRow {\n    background-color: rgba(0, 0, 0, .1);\n}\n\n.cell,\n.headerCell,\n.leftCell {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.headerCell {\n    background-color: #fff;\n    padding: 0 8px;\n    white-space: nowrap;\n    max-width: 100%;\n    text-overflow: ellipsis;\n}\n\n.headerCell:first-of-type {\n    border-left: none;\n}\n\n.cell {\n    background-color: #fff;\n    border-bottom: 1px solid #f2f2f2;\n    font-size: 13px;\n    padding: 0 8px;\n    white-space: nowrap;\n    cursor: pointer;\n    color: #737373;\n}\n\n.cell.hover {\n    background:#f7fbff;\n}\n\n.cell.active {\n    margin-top: -1px;\n    border-top: 1px solid #2d7ff9;\n    border-bottom: 1px solid #2d7ff9;\n    z-index: 1000 !important;\n}\n\n.cellFocus {\n    border-color: transparent;\n    box-shadow: 0 0 0 2px #2d7ff9 !important;\n    border-radius: 1px;\n    z-index: 1000 !important;\n}\n\n.addRecordCell {\n    border-right: none;\n    border-left: none;\n}\n\n.headerCell,\n.leftCell {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
